var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"lazy-validation":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('div',{staticClass:"col-12 col-md-6"},[_c('Input',{staticClass:"mx-4",attrs:{"data":{
          text: this.text.firstname,
          name: 'firstname',
          onkeyup: true,
          onblur: true,
          rules: this.firstnameRules,
          value: this.user.info.firstname
        }},on:{"childToParent":_vm.inputFormNameFirst}})],1),_c('div',{staticClass:"col-12 col-md-6"},[_c('Input',{staticClass:"mx-4",attrs:{"data":{
          text: this.text.lastname,
          name: 'lastname',
          onkeyup: true,
          onblur: true,
          rules: this.lastnameRules,
          value: this.user.info.lastname
        }},on:{"childToParent":_vm.inputFormNameLast}})],1)]),_c('v-row',{attrs:{"no-gutters":""}},[_c('div',{staticClass:"col-12"},[_c('Input',{staticClass:"mx-4",attrs:{"data":{
          text: this.text.address,
          name: 'address',
          onkeyup: true,
          onblur: true,
          rules: this.addressRules,
          value: this.user.info.address
        }},on:{"childToParent":_vm.inputFormAddress}})],1)]),_c('ZipcodeCityLookup',{attrs:{"user":this.user,"zipcode":this.user.info.zipcode,"city":this.user.info.city,"cityInputIsDisabled":false,"rules":_vm.valRules},on:{"zipcodeChanged":_vm.inputFormZipcode,"cityChanged":_vm.inputFormCity}}),_c('v-row',{attrs:{"no-gutters":""}},[_c('div',{staticClass:"col-12 col-md-6"},[_c('Input',{staticClass:"mx-4",attrs:{"data":{
          text: this.text.email,
          name: 'email',
          onkeyup: true,
          onblur: true,
          rules: this.emailRules,
          value: this.user.info.email
        }},on:{"childToParent":_vm.inputFormEmail}})],1),_c('div',{staticClass:"col-12 col-md-6"},[_c('Input',{staticClass:"mx-4",attrs:{"data":{
          id: 1,
          text: this.text.phone,
          name: 'phone',
          onkeyup: true,
          onblur: true,
          rules: this.phoneRules,
          value: this.user.info.phone
        }},on:{"childToParent":_vm.inputFormNumberPhone}})],1)]),_c('v-row',{attrs:{"no-gutters":""}},[_c('div',{staticClass:"col-12 mt-4"},[_c('Checkbox',{staticClass:"mx-4",attrs:{"item":{
          text: this.text.checkbox,
          rules: this.acceptedRules,
          checked: this.user.info.accepted
        }},on:{"childToParent":_vm.inputFormAccepted}})],1)]),(_vm.user.specialProperties.forwarding.endpoint != '')?_c('v-row',{attrs:{"no-gutters":""}},[_c('div',{staticClass:"col-12 mb-5"},[_c('Checkbox',{staticClass:"mx-4",attrs:{"item":{
          text: this.text.marketingConsent,
          checked: _vm.user.specialProperties.forwarding.marketingConsent
        }},on:{"childToParent":_vm.marketingConsentAccepted}})],1)]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }